<div class="modal-header text-center" style="color: rgb(255, 255, 255);background-color: #0d47a1">
  <h4 class="modal-title w-100">{{x_titulo}}</h4>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClosemodal()">
    <span aria-hidden="true" class="white-text">&times;</span>
  </button>
</div>
<div class="modal-body" style="background-color: rgb(229, 232, 232)">
  <mdb-card>
        <mdb-card-body>
          <div style="height: 505px;" >
            <pdf-viewer [src]="pdfSource" [original-size]="false"></pdf-viewer>
          </div>
          </mdb-card-body>
    </mdb-card>
          <br>
          <div class="justify-content-center" style="text-align: center;">
            <button mdbBtn type="button" (click)="onDescargarArchivo('.pdf')" size="md" class="btn btn-teal btn-rounded" mdbWavesEffect>
                <mdb-icon fas icon="file-download" class="mr-2"></mdb-icon>DESCARGAR</button>
          </div>

</div>
